import { Route, Routes, Navigate } from "react-router-dom";
import App from "./App";
import ClientPage from "./pages/clientPage/ClientPage";

export interface IComponentProps {}

const AppRouting: React.FC<IComponentProps> = function () {
  return (
    <Routes>
      <Route path="" element={<App />}>
        <Route path="/clients/:id" element={<ClientPage />} />
        <Route path="*" element={<Navigate to="/clients/" replace />} />
      </Route>
    </Routes>
  );
};

export { AppRouting };
